module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.html
// module id = ./src/app/admin/admin.component.html
// module chunks = main